import { AppState } from '../reducers/RootReducer';
import { createSelector } from 'reselect';
import { IUserSettings } from '../models/Models';

const getUserSettings = (state: AppState): IUserSettings => state.userSettings.userSettings;

export const getUserSettingsSelector = createSelector(getUserSettings, (userSettings) => userSettings);
